module.exports = __webpack_public_path__ + "static/img/addquestion-ces.278289c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/addquestion-ces.png
// module id = Zxyf
// module chunks = 1